import React from 'react';

/**
 * Compact chip: whether an assigned service counts toward driver liquidation (approval_status).
 */
export function SettlementApprovalChip({ order, t, className = '' }) {
  if (!order?.driver_id) return null;
  const approved = order.approval_status === 'approved' || order.include_in_driver_invoice;
  if (approved) {
    return (
      <span
        className={`text-[10px] px-2 py-0.5 rounded-full font-semibold bg-emerald-100 text-emerald-900 ${className}`}
        title={t('admin_settlement_chip_tooltip')}
      >
        {t('admin_settlement_chip_ok')}
      </span>
    );
  }
  if (order.approval_status === 'rejected') {
    return (
      <span
        className={`text-[10px] px-2 py-0.5 rounded-full font-semibold bg-red-100 text-red-800 ${className}`}
        title={t('admin_settlement_chip_tooltip')}
      >
        {t('admin_settlement_chip_rejected')}
      </span>
    );
  }
  if (order.approval_status === 'pending_approval') {
    return (
      <span
        className={`text-[10px] px-2 py-0.5 rounded-full font-semibold bg-amber-200 text-amber-950 ring-1 ring-amber-400/70 ${className}`}
        title={t('admin_settlement_chip_tooltip')}
      >
        {t('admin_settlement_chip_need_approval')}
      </span>
    );
  }
  return (
    <span
      className={`text-[10px] px-2 py-0.5 rounded-full font-semibold bg-gray-100 text-gray-700 ${className}`}
      title={t('admin_settlement_chip_tooltip')}
    >
      {t('admin_settlement_chip_open')}
    </span>
  );
}
